import {Model} from 'MWC';

const installment_from_statement = 'installment_from_statement_new',
    oneTimeCommission = 'one_time_commission',
    timeUnit = 'time_unit',
    realRate = 'real_rate',
    months = 12,
    hundredPercent = 100,
    daysInTheYear = 365,
    bankDays = 360;

export default class extends Model {
    static fields;

    constructor(data, selectedType) {
        super();
        this.selectedType = installment_from_statement;
        this.creditSum = data.min;
        this.loanTerm = 0;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.creditCost = 0;
        this.shopCreditTerm = data.terms[0];
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;
        this.calculateIndicators();
    }

    getCreditSum() {
        return +this.creditSum;
    }

    setCreditSum(value) {
        this.creditSum = value;
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getFixAmounts() {
        return this.fields.fix_amounts;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getTerms() {
        return this.fields.terms;
    }

    getMinTermEdge() {
        return this.fields.terms[0];
    }

    getMaxTermEdge() {
        return this.fields.terms[this.fields.terms.length - 1];
    }

    setCurrentCreditTerm() {
        this.shopCreditTerm = this.fields.terms[0];
    }

    getTimeUnit() {
        return this.fields[timeUnit];
    }

    getCreditTerm() {
        return +this.shopCreditTerm;
    }

    getCreditRate() {
        return this.fields.rate;
    }

    getRealRate() {
        return this.fields[realRate][this.getCreditTerm() - 2];
    }

    getRate() {
        return this.fields.rate;
    }

    getMonthCommission() {
        return this.fields.month_commission;
    }

    getOneTimeCommission() {
        return this.fields[oneTimeCommission];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getOverpayment() {
        return this.overpayment;
    }

    setOverpayment(value) {
        this.overpayment = value;
    }

    getCreditCost() {
        return this.creditCost;
    }

    setCreditCost(value) {
        this.creditCost = value;
    }

    calculateCreditSum() {
        const creditSum = this.getCreditSum();
        return +creditSum + (creditSum * this.getOneTimeCommission()) / hundredPercent;
    }

    resetIndicators() {
        this.setCreditSum(this.getMinSumEdge());
        this.setCurrentCreditTerm();
    }

    calculateIndicators() {
        const creditSum = this.calculateCreditSum(),
            interestRate = this.getCreditRate(),
            monthInterestRate = interestRate / months,
            term = this.getCreditTerm(),
            monthCommission = this.getMonthCommission();

        const requiredPayment =
                Math.round(
                    ((this.creditSum * this.fields.month_commission) / 100 +
                        this.creditSum / this.shopCreditTerm) *
                        100
                ) / 100,
            overpayment =
                Math.round(
                    ((this.creditSum * this.fields.month_commission) / 100) *
                        this.shopCreditTerm *
                        100
                ) / 100;

        this.setRequiredPayment(requiredPayment);
        this.setOverpayment(overpayment);

        const creditCost = +this.creditSum + overpayment;
        this.setCreditCost(creditCost);
    }
}
